import React from 'react'
import PropTypes from 'prop-types'
import { Logo, PrintLogo, PreviewLogo } from '../img'
import DateClick from './DateClick'
import SearchUserField from './SearchUserField'
import SearchUserChipField from './SearchUserChipField'
import { Avatar, Chip, Grid, IconButton, TextField, Switch, FormControlLabel } from '@material-ui/core'
import { Done, DoneAll, Event, Save } from '@material-ui/icons'
import UserGroupDetail from './UserGroupDetail'
import { ReadDetailDialog } from './DocDialogs'
import { EventDialog } from './EventDialog'
import { withStyles } from '@material-ui/core/styles'
import RemoveRedEye from '@material-ui/icons/RemoveRedEye'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import Typography from '@material-ui/core/Typography'
import { CustomTooltip } from './CustomTooltip'
import DocRequiredField from './DocRequiredField'

const styles = theme => ({
  root: {
    '@media print': {
      marginTop: '-10em',
      border: 'none',
      width: '880px',
    }
  },
  saveMessage: {
    float: 'right',
    marginBottom: '0px !important',
    backgroundColor: 'transparent !important'
  },
  saveMessageChip: {
    color: theme.palette.grey[500],
    backgroundColor: 'transparent !important',
    '& span': {
      fontSize: '16px',
      padding: '0px !important'
    }
  },
  saveMessageChipSuccess: {
    color: theme.palette.primary.main,
    backgroundColor: 'transparent !important',
    '& span': {
      fontSize: '16px',
      padding: '0px !important'
    }
  },
  saveMessageAvatar: {
    color: theme.palette.primary.main,
    backgroundColor: 'transparent !important',
    height: 30,
  },
  place_and_date: {
    textAlign: 'right',
    '@media print': {
      marginLeft: '-4.5em'
    },
    "@media (max-width: 600px)": {
      textAlign: 'left',
    },
  },
  data_label: {
    color: theme.palette.grey[500],
    fontWeight: 'bold',
  },
  data_label_head: {
    color: theme.palette.grey[500],
    fontWeight: 'bold',
    textAlign: 'right'
  },
  present: {
    marginTop: '8px',
    fontWeight: 'bold',
    '@media print': {
      marginLeft: '-2.5em'
    }
  },
  cc_btn: {
    margin: '0px 5px'
  },
  cc_txt: {
    fontSize: 16
  },
  cc_area: {
    border: '1px solid ' + theme.palette.grey[400],
    borderRadius: '5px',
    padding: '10px',
    boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
    marginTop: 10
  },
  cc_close_icon: {
    padding: 0
  },
  cc_close: {
    textAlign: 'right'
  },
  cc_fill: {
    backgroundColor: theme.palette.secondary.purpleLight,
    '& span': {
      '& p': {
        color: '#6D6D6D',
      }
    }
  },
  cc_no_fill: {
    backgroundColor: 'transparent'
  },
  purple: {
    color: theme.palette.primary.main,
    fontWeight: 'bold'
  },
  input:{
    color: '#000',
    padding: '7px 0 7px',
  },
  input_disabled: {
      color: '#000',
      fontWeight: 'bold',
      padding: '7px 0 7px',
  },
  input_disabled_no_bold: {
      color: '#000',
      padding: '7px 0 7px',
  },
  preview:{
    fontSize: 8,
    color: '#000',
    padding: '0',
    '& p':{
      fontSize: 8,
      color: '#000',
    },
    '& b':{
      fontSize: 8,
      color: '#000'
    }
  },
  preview_bold:{
    fontWeight: 'bold',
    fontSize: 8,
    color: '#000',
    padding: '0',
    '& p':{
      fontSize: 8,
      color: '#000',
    },
    '& b':{
      fontSize: 8,
      color: '#000'
    }
  },
  fix_place:{
    marginTop: 80,
    textAlign: 'right',
    "@media (max-width: 600px)": {
      marginTop: 0,
    },
    "@media print": {
      textAlign: 'left',
    },
  },
  subject:{
    '@media print': {
      marginLeft: '-2.5em'
    }
  },
  folio:{
    '@media print': {
      marginLeft: '-2.5em'
    }
  }
})

class DocHeader extends React.Component {
  state = {
    groupModal: false,
    readModal: false,
    eventModal: false,
    cc_section: false,
    external: this.props.external,
    ext_name: this.props.ext_name,
    ext_job_title: this.props.ext_job_title
  }

  openGroupModal = e => {
    this.setState({groupModal: true})
  }

  closeGroupModal = e => {
    this.setState({groupModal: false})
  }

  openEventModal = e => {
    this.setState({eventModal: true})
  }

  closeEventModal = e => {
    this.setState({eventModal: false})
  }

  openReadModal = e => {
    this.setState({readModal: true})
  }

  closeReadModal = e => {
    this.setState({readModal: false})
  }

  onGroupChange = group => {
    const {to, onToChange} = this.props
    const toUser = {
      ...to,
      name: {...to.name, full: group.short_name},
      job_title: group.long_name,
      group: true,
      id: group.id
    }
    onToChange(toUser)
  }


  onChangeCC = () => {
    this.setState({cc_section: true})
  }

  onCloseCC = () => {
    this.setState({cc_section: false})
  }

  changeExternalType = () => {
    const { external } = this.state;
      this.setState({
        external: !external,
        ext_name: '',
        ext_job_title: ''
      })
      //establezco si el tipo de destinatario del oficio es externo o no
      this.props.changeTypeAddressee(!external);
  }

  //funcion para mandar los datos del destinatario externo segun se tecleen
  onChangeExtAddressee = (value, field) => {
    this.setState(ps => {
      this.props.changeAddressee(field,value)
      const ns = { ...ps };
      ns[field] = value;
      return ns;
    });
  };

  //funcion para mandar los datos del asunto segun se tecleen
  onChangeSubject = (value) => {
    this.props.onSubjectChange(value)
  };

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.folio !== this.props.folio){
      this.setState({ external: this.props.external, cc_section: false })
    }
  }

  render () {
    const header_text = 'align-right bold'
    const {
      classes,
      onDateChange,
      onToChange,
      onEventSave,
      disabled,
      to,
      date,
      folio,
      read,
      canViewReadDetail,
      readDetail,
      event,
      saveMessage,
      ccList,
      onAddCC,
      onAddExternalCC,
      onDeleteCC,
      ccNote,
      onCcNoteChange,
      onReset,
      alreadyAdded,
      readCount,
      preview,
      can_edit_date,
      location,
      subject
    } = this.props

    const { external, ext_name, ext_job_title } = this.state;

    let switch_addressee_option = (
        <Grid item xs={'auto'} sm={'auto'} md={'auto'} lg={'auto'} xl={'auto'} style={{ marginLeft: '1.5%' }}>
        <FormControlLabel
          control={
            <Switch
              checked={external}
              onChange={this.changeExternalType}
              name="external"
              color="primary"
            />}
            label="Oficio externo"
          />
      </Grid>
    );

    let header_addressee = (
      <Grid item xs={5} sm={5} md={5} lg={5} xl={5} className={classes.data_label}>Destinatario</Grid>
    );

    let header_subject = (
      <React.Fragment>
        <Grid item xs={5} sm={5} md={5} lg={5} xl={5} className={classes.data_label}>Asunto</Grid>
        {switch_addressee_option}
      </React.Fragment>
    );

    if(disabled){
      header_addressee = null;
      header_subject = null;
    }

    let messageAvatar = (
      <Chip className={saveMessage === 'Guardado con éxito' ? classes.saveMessageChipSuccess : classes.saveMessageChip}
       label={saveMessage}
       avatar={saveMessage === 'Guardado con éxito' ? (<Avatar className={classes.saveMessageAvatar}><Save style={{ height: 24, width: 24 }}/></Avatar>) : null}
      />
    );

    if(saveMessage === ''){
      messageAvatar = null;
    }

    let avatar_section = (
      <Grid item className={classes.saveMessage}>
        {messageAvatar}
      </Grid>
    );

    if(preview){
      avatar_section = null;
    }

    let toAddressee = (
      <Grid item xs={12} sm={12} md={8} lg={8} xl={8} >
        <SearchUserField
          to={to}
          onChange={onToChange}
          onReset={onReset}
          disabled={disabled}
          preview={preview}
          includeGroups
          placeholder='Buscar Usuario o grupo'
        />
      </Grid>
    );

    if(external){
      const grid = 6 ;

      const addresseeName = (
        <Grid item xs={grid} sm={grid} md={grid} lg={grid} xl={grid}>
          <TextField
            disabled={disabled}
            placeholder="Nombre con titulo"
            value={ext_name}
            fullWidth
            InputProps={{
              disableUnderline: disabled? true : false,
              classes: {
                input: disabled? preview? classes.preview : classes.input_disabled : classes.input
              },
            }}
            onChange={e => {
              this.onChangeExtAddressee(e.target.value, "ext_name");
            }}
          />
        </Grid>
      );

      let addresseeJobTitle = (
        <Grid item xs={grid} sm={grid} md={grid} lg={grid} xl={grid}>
          <TextField
            disabled={disabled}
            placeholder="Puesto"
            value={ext_job_title}
            fullWidth
            type={preview? 'hidden' : 'text' }
            InputProps={{
              disableUnderline: disabled? true : false,
              classes: {
                input: disabled? preview? classes.preview : classes.input_disabled : classes.input
              },
            }}
            onChange={e => {
              this.onChangeExtAddressee(e.target.value, "ext_job_title");
            }}
          />
        </Grid>
      );

      let addresseeComponent = (
        <Grid item xs={8} sm={8} md={8} lg={8} xl={8} className="bold">
          <Grid container justify="flex-start" spacing={8}>
            {addresseeName}
            {addresseeJobTitle}
          </Grid>
        </Grid>
      );

      if(disabled && !preview){
        addresseeComponent = (
            <React.Fragment>
              {addresseeName}
            </React.Fragment>
          );
      }

      toAddressee = addresseeComponent;
    }

    let groupButton = null;

    if((to.group || to.id === null) && (!preview)){
      groupButton = (
        <React.Fragment>
          <IconButton onClick={this.openGroupModal} disabled={external? true : false}>
            {to.group ?
              <CustomTooltip  title="Ver información del grupo" placement="right">
                <RemoveRedEye/>
              </CustomTooltip>
               :null}
          </IconButton>
          <UserGroupDetail
            group={{
              ...to,
              short_name: to.group ? to.name.full : '',
              long_name: to.group ? to.job_title : ''
            }}
            onChange={this.onGroupChange}
            open={this.state.groupModal}
            onClose={this.closeGroupModal}
            readOnly={true}
          />
        </React.Fragment>
      );
    }

    let ccButton = null;
      if(!disabled && ((to.group) || (to.id !== null) || (!!ext_name && ext_name.length > 0))){
      ccButton = (
        <CustomTooltip title="Agregar con copia" placement="right">
          <IconButton
            className={classes.cc_btn + ' ' + (ccList.length >= 1 ? classes.cc_fill : classes.cc_no_fill)}
            onClick={this.onChangeCC}
            disabled={(((this.props.to.id !== null) || (external)) && !disabled) ? false : true}>
            <Typography className={classes.cc_txt}>CC</Typography>
          </IconButton>
        </CustomTooltip>
      );
    }

    let sectionReadDetail = null;

    if(canViewReadDetail === true){
      sectionReadDetail = (
        <React.Fragment>
          <IconButton onClick={this.openReadModal}>
            {read ? (
              <CustomTooltip  title="Visto" placement="right">
                <DoneAll style={{fontSize: 26}} />
              </CustomTooltip>
            ) : (
              <CustomTooltip  title="Entregado" placement="right">
                <Done style={{fontSize: 26}} />
              </CustomTooltip>
            )}
          </IconButton>
          <ReadDetailDialog
            open={this.state.readModal}
            onClose={this.closeReadModal}
            detail={readDetail}
            readCount={readCount}
          />
        </React.Fragment>
      );
    }

    let eventButton = null;

    if((!disabled || event.id) && (to.id || external)){

      eventButton = (
        <Grid item xs={'auto'} sm={'auto'} md={'auto'} lg={'auto'} xl={'auto'} >
          <CustomTooltip title={disabled? "Detalles del evento" : "Agregar evento a oficio"} placement="right">
            <IconButton onClick={this.openEventModal} disabled={preview? true : false} >
              <Event title="Eventos" style={{ fontSize: preview? 14 : 'inherit' }} />
            </IconButton>
          </CustomTooltip>
          <EventDialog
            open={this.state.eventModal}
            onClose={this.closeEventModal}
            onEventSave={onEventSave}
            disabled={disabled}
            folio={folio}
            event={event}
            key={event.id}
          />
        </Grid>
      );
    }

    //data addressee
    const data_addressee = (
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Grid container className="greeting" justify="space-between" spacing={0}>
          <Grid item xs={10} sm={10} md={10} lg={10} xl={10} className="bold" >
            <Grid container justify="flex-start">
              {toAddressee}
              <Grid>
                {groupButton}
                {ccButton}
              </Grid>
            </Grid>
            <Grid item>{external? ext_job_title : to.group? to.job_title : ((typeof to.job_title !== 'undefined') && (to.job_title !== null))? to.job_title : ''}</Grid>
            <Grid item>{((typeof to.department !== 'undefined') && (to.department !== null))? to.department : ' '}</Grid>
            <Grid item>{to.institution}</Grid>
          </Grid>
          <Grid item>
            <Grid container
              direction="row"
              justify="flex-end"
              alignItems="flex-start"
              >
                {eventButton}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );

    //content section
    let content_section = (
        <Grid container>
          <Grid item lg={1} className={classes.data_label} style={{marginTop: 20}}>
            {disabled ? '' : 'Contenido'}
          </Grid>
        </Grid>
    );

    if(preview){
      content_section = null;
    }

    //cc section
    let copy_section = null;

    if(!disabled && this.state.cc_section){
      copy_section = (
          <Grid container>
            <Grid item sm={12} md={12} lg={12} xs={12} className={classes.cc_area}>
              <Grid item sm={12} md={12} lg={12} xs={12}
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="flex-start">
                <Grid item sm={11} md={11} lg={11} xs={11} className={classes.purple}>CC</Grid>
                <Grid item sm={1} md={1} lg={1} xs={1} className={classes.cc_close}>
                  <CustomTooltip title="Ocultar con copia" placement="right">
                    <IconButton className={classes.cc_close_icon} onClick={this.onCloseCC}>
                      <VisibilityOffIcon />
                    </IconButton>
                  </CustomTooltip>
                </Grid>
              </Grid>
              <Grid container direction="row" style={{marginTop: '1em'}}>
                <Grid item sm={12} md={12} lg={12} xs={12}>
                  <SearchUserChipField
                    disabled={disabled}
                    includeGroups
                    ccList={ccList}
                    onAddCC={onAddCC}
                    onAddExternalCC={onAddExternalCC}
                    onDeleteCC={onDeleteCC}
                    ccNote={ccNote}
                    onCcNoteChange={onCcNoteChange}
                    alreadyAdded={alreadyAdded}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>);
    }

    let subjectLabel = null;
    let subjectContent = (
      <TextField
        fullWidth
        onChange={e => {
          this.onChangeSubject(e.target.value);
        }}
        placeholder="Asunto del oficio"
        disabled={disabled}
        value={((disabled) && (subject === '' || typeof subject !== 'string'))? 'Sin asunto' : subject}
        inputProps={{
          maxLength: 70,
        }}
        InputProps={{
          maxLength: 70,
          disableUnderline: disabled? true : false,
          classes: {
            input: disabled? preview? classes.preview : classes.input_disabled_no_bold : classes.input
          }
        }}
      />
    );

    if(disabled || preview){
      subjectLabel = (
        <TextField
          fullWidth
          disabled={true}
          value={`Asunto: ${subject}`}
          InputProps={{
            disableUnderline: true,
            classes: {
              input: preview? classes.preview_bold : classes.input_disabled
            }
          }}
        />
      );

      subjectContent = null;

    }

    return (
      <Grid
        container
        spacing={0}
        alignItems="flex-start"
        className={classes.root}
      >
        <Grid item sm={12} md={12} lg={12} xs={12}>
          <Grid container direction="row">
            <Grid container justify="flex-end">
              <Grid item sm={5} md={5} lg={5} xs={5}>
                {avatar_section}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item  xs={12} sm={12} md={2} lg={4} xl={7}>
          <Grid container>
            <img src={preview? PreviewLogo : Logo} alt="logo" className={preview? "logo-doc-preview" : "logo-doc" }/>
            <img src={PrintLogo} alt="logo" className="print-logo"/>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={10} lg={8}  xl={5} className={classes.fix_place}>
          {disabled ? '' : <Grid item className={classes.data_label_head}>Lugar y fecha</Grid>}
          <DateClick
            date={date}
            onChange={onDateChange}
            disabled={disabled}
            preview={preview}
            can_edit_date={can_edit_date}
            location={location}
          />
          <Grid item sm={12} md={12} lg={12} xs={12} xl={12} className={classes.folio}>
            {disabled ? '' : <Grid item className={classes.data_label_head} style={{marginTop: 25}}>Número de
              oficio</Grid>}
            <TextField
              value={folio}
              className={header_text + " " + (disabled ? 'disabled' : '') + " " + (preview ? 'preview_text' : '')}
              disabled={true}
              InputProps={{
                disableUnderline: true,
              }}
            />
          </Grid>
        </Grid>
        <Grid container className={classes.subject} style={{ alignItems: 'center', marginBottom: disabled? 0 : 20, marginTop: preview? 0 : disabled? 50 : 0  }}>
          {header_subject}
          <Grid item xs={7} sm={7} md={11} lg={8} xl={7} style={{ maxWidth: disabled? '100%' : '55.6%' }}>
            {subjectLabel}
            {subjectContent}
          </Grid>
          <Grid item xs={5} sm={5} md={1} lg={4} xl={5} style={{ textAlign: 'right' }}>
            {sectionReadDetail}
          </Grid>
        </Grid>
        <Grid container style={{ alignItems: 'center', marginBottom: disabled? 0 : 13 }}>
          {header_addressee}
        </Grid>
          {data_addressee}
          {copy_section}
        <Grid container>
          <Grid item xs={12} sm={12} md={7} lg={7} style={{ paddingRight: '3%' }}>
            <DocRequiredField valid={this.props.to.id || (!!this.state.ext_name && this.state.ext_name.length !== 0)} message={'*Seleccionar al menos un destinatario'} />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} className={classes.present}>
            PRESENTE
          </Grid>
        </Grid>
        {content_section}
      </Grid>
    )
  }
}

DocHeader.propTypes = {
  onDateChange: PropTypes.func.isRequired,
  date: PropTypes.string.isRequired,
  folio: PropTypes.string.isRequired,
  to: PropTypes.object.isRequired,
  event: PropTypes.object.isRequired,
  onToChange: PropTypes.func.isRequired,
  onEventSave: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  read: PropTypes.bool.isRequired,
  canViewReadDetail: PropTypes.bool.isRequired,
  readDetail: PropTypes.array.isRequired,
  onAddCC: PropTypes.func.isRequired,
  onAddExternalCC: PropTypes.func.isRequired,
  onDeleteCC: PropTypes.func.isRequired,
  ccNote: PropTypes.string.isRequired,
  onCcNoteChange: PropTypes.func.isRequired
}

export default withStyles(styles)(DocHeader)



// WEBPACK FOOTER //
// ./src/components/DocHeader.js